import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ICardTitleFormatter } from '../../../schema/interfaces/card-title-formatter';

export class FusTitleFormatter implements ICardTitleFormatter {
  format(callcard: CallCard): string {
    return `${callcard.Id} ${callcard.Identifier}`;
  }
}
